export default __webpack_public_path__ + "static/media/polaroid-ice.9308056a.png";